import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import { VisibilityOutlined as VisibilityIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(7),
        paddingLeft: theme.spacing(3),
    },
    titleWrapper: {
        padding: theme.spacing(1, 0),
    },
    title: {
        color: theme.palette.primary.main,
        fontSize: 18,
        fontWeight: 700,
        lineHeight: '24px',
        marginBottom: theme.spacing(3.5),
    },
    headCell: {
        color: theme.palette.primary.dark,
        fontSize: 12,
        fontWeight: 700,
    },
    cell: {
        padding: theme.spacing(1, 2),
    },
    iconCell: {
        padding: theme.spacing(0, 1),
        textAlign: 'center',
        width: 64,
    },
    emptyBox: {
        padding: theme.spacing(3),
        textAlign: 'center',
    },
}));

function DeletedRisksTable({ risks }) {
    const classes = useStyles();
    const intl = useIntl();

    if (!risks || !risks.length) return null;

    return (
        <Box className={classes.container}>
            <Box className={classes.titleWrapper}>
                <Typography className={classes.title}>
                    {intl.formatMessage({ id: 'risks.deletedRisks', defaultMessage: 'Riesgos eliminados' })}
                </Typography>
            </Box>

            <TableContainer component="div">
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}>
                                {intl.formatMessage({ id: 'risks.columns.title', defaultMessage: 'Título del riesgo' })}
                            </TableCell>
                            <TableCell className={classes.headCell}>
                                {intl.formatMessage({ id: 'risks.columns.deleteDate', defaultMessage: 'Fecha de eliminación' })}
                            </TableCell>
                            <TableCell className={classes.headCell}>
                                {intl.formatMessage({ id: 'risks.columns.deleteUser', defaultMessage: 'Usuario que realizó la acción' })}
                            </TableCell>
                            <TableCell className={classes.headCell} align="center" />
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {risks.map((risk) => (
                            <TableRow key={risk.id} hover>
                                <TableCell className={classes.cell}>
                                    <Typography
                                        variant="body2"
                                        style={{ fontWeight: 600, fontSize: 12, lineHeight: '24px' }}
                                    >
                                        {risk.title}
                                    </Typography>
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    {risk.deleteDate ? moment(risk.deleteDate).format('DD/MM/YYYY HH:mm [hs.]') : '-'}
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    {risk.deleteUser || '-'}
                                </TableCell>
                                <TableCell className={classes.iconCell}>
                                    <IconButton
                                        component={Link}
                                        size="small"
                                        to={`/risks/${risk.id}`}
                                    >
                                        <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

DeletedRisksTable.propTypes = {
    risks: PropTypes.arrayOf((PropTypes.shape())),
};

export default DeletedRisksTable;
